import React, { Dispatch } from "react";
import DelegationForm from "../DelegationForm/DelegationForm";
import { RootReducer } from "../../store/reducers";
import { connect, useSelector } from "react-redux";
import { clearDelegeeDetails, disposeError, getPedestrianProducts, inviteDelegee } from "../../services/pedestrianRights.service";
import { ParkingRightsRequestModel } from "../../models/ParkingRightsRequestModel";
import { DelegationFormDetails } from "../DelegationForm/DelegationFormDetails";
import { InvitePedestrianRightRequestModel, PedestrianProduct } from "../../models/InvitePedestrianRightRequestModel";
import { ParkingProductModel, ParkingProductType } from "../../models/ParkingProductModel";
import { PedestrianProductModel } from "../../models/PedestrianProductModel";
import { DataType } from "../../store/reducers/parking-products";

interface IPedestrianProps extends StateProps, DispatchProps {
    onClose: () => void;
    refreshHandler: () => void;
  }

const PedestrianForm: React.FC<IPedestrianProps> = (props) => {
    const {
        pedestrianRights,
        getPedestrianProduct,
        invitePedestrianDelegee
    } = props;

    const getDelegationFormDetails = () => {
        const details: DelegationFormDetails = {
           delegeeDetails: pedestrianRights.delegeeDetails,
           parkingProducts: mapToParkingProducts(pedestrianRights.pedestrianProducts),
           error: null,
           isBulkImportCompleted: true,
           loading: false
        };
    
        return details;
      } 

    const inviteDelegee = (parkingRights: ParkingRightsRequestModel, callback?: () => void) => {
        const request = createInvitePedestrianRightRequestModel(parkingRights);
        invitePedestrianDelegee(request, callback);
    }

    const createInvitePedestrianRightRequestModel = (parkingRights: ParkingRightsRequestModel): InvitePedestrianRightRequestModel  =>{
        const inviteRequetModel: InvitePedestrianRightRequestModel = {
            customerId: parkingRights.seasonTicketOwnerCrmId,
            name: parkingRights.name,
            email: parkingRights.email,
            pedestrianProducts:  parkingRights.pmcIds.map(pmcId => ({
                pmcId: pmcId,
                seasonTicketReferenceId: pedestrianRights.pedestrianProducts.find(x => x.pmcId === pmcId)?.seasonTicketReferenceId
            } as PedestrianProduct))
        };
    
        return inviteRequetModel;
    }

    // We map it to ParkingProducts because ParkingRightsGrid components is to hard coupled to parkingProducts
    const mapToParkingProducts = (pedestrianProductModels : PedestrianProductModel[]) :  DataType<ParkingProductModel[]> => {
        const list = pedestrianProductModels.map(pedestrianProductModel => {
            return {
                id: pedestrianProductModel.seasonTicketId,
                pmcId: pedestrianProductModel.pmcId,
                pmcName: pedestrianProductModel.pmcName,
                location: pedestrianProductModel.locationName,
                totalDelegatedPedestrianRights: pedestrianProductModel.totalDelegatedPedestrianRights,
                totalPedestrianRights: pedestrianProductModel.totalPedestrianRights,
                totalParkingRights: 0,
                totalDelegatedParkingRights: 0,
                totalAssignedParkingRights: 0,
                hasUnlimitedEntryRights: false,
                productType: ParkingProductType.PedestrianAccess
            };
        });

        const data : DataType<ParkingProductModel[]> = {
            loading: false,
            data: list,
            error: null
        };        

        return data;
    }

    return (
      <div>
        <DelegationForm 
            onClose={props.onClose} 
            refreshHandler={props.refreshHandler}
            getProducts={getPedestrianProduct}
            inviteDelegee={inviteDelegee}
            updateDelegation={() => {}}
            getDelegeeDetails={() => {}}
            clearDelegeeDetails={clearDelegeeDetails}
            resetBulkImportProgress={() => {}}
            getBulkImportStatus={() => {}}
            disposeError={disposeError}
            isEditMode={false}
            translationContextName="pedestrianForm"
            disableMultipleOption={true}
            delegationFormDetails={getDelegationFormDetails()} />
      </div>
    );
};



const mapStateToProps = (state: RootReducer) => {
    const { pedestrianRights } = state;

    return {
        pedestrianRights
    };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
    getPedestrianProduct: (seasonTicketOwnerCrmId: string, language: string) =>
        dispatch(getPedestrianProducts(seasonTicketOwnerCrmId, language)),
    invitePedestrianDelegee: (request: InvitePedestrianRightRequestModel, callback?: () => void) => {
        dispatch(inviteDelegee(request, callback));
    },
    clearDelegeeDetails: () => dispatch(clearDelegeeDetails),
    disposeError: () => dispatch(disposeError),
    }
);
  
type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
  
export default connect(mapStateToProps, mapDispatchToProps)(PedestrianForm);